module.exports = __webpack_public_path__ + "img/icon_2.d395064c.png";